import {
  EoDropdownConfig,
  IEoDropdownConfig,
} from '../eo-dropdown/eo-dropdown.model';
import { Country } from './country.model';

export interface IEoCountryDropdownConfig extends IEoDropdownConfig<Country> {
  type?: any;
}

export class EoCountryDropdownConfig
  extends EoDropdownConfig<Country>
  implements IEoCountryDropdownConfig
{
  override type?: any;

  constructor();
  constructor(obj: IEoCountryDropdownConfig);
  constructor(obj?: IEoCountryDropdownConfig) {
    super(obj as IEoCountryDropdownConfig);
    this.type = 'countryDropdown';
  }
}
